<template lang="pug">	
	.easy-creative--questions.question-form.flex-col.space-large.full-width
		template(v-if="!isLoading")
			template(v-if="activeStep")
				.flex-row.space.step
					.step-image-holder(v-if="activeStep.Picture && activeStep.Picture.FileName")
						.step-image(:style="{ '--imageUrl': `url('${activeStep.Picture.AzureFileUrl}')` }")
					.flex-col.space.full-width.max-limited
						.flex-row.align-center.space.justify
							.flex-row.space.align-center
								.font-large {{activeStep.Name}}
							.flex-row.space.align-center
								template(v-if="activeStep.Hint")
									.clickable.hoverable(:id="`hint_${activeStep.Oid}`")
										fas.hint.hoverable(icon="circle-question", @mouseenter="isTooltipVisible = true", @mouseleave="isTooltipVisible = false", size="lg")
									DxPopover(:visible="isTooltipVisible" :hide-on-outside-click="false" :target="`#hint_${activeStep.Oid}`", :maxWidth="500")
										span {{activeStep.Hint}}
						.font-small(v-if="activeStep.Description") {{activeStep.Description}}
						.actions-divider.full-width
				.flex-col.space-large(v-if="activeStep")
					.flex-row.space(v-for="row in activeStep.RowsMain", v-if="row.some(f => f && f.__isVisible && !f.__hidden)")
						Question(v-for="(question, idx) in row.filter(f => f.__isVisible)", :question="question", :info="info", :questionTypes="questionTypes", :key="question.Oid", :requiredExists="requiredExists",
							:error="requiredExists && question.IsRequired && !question.__filled ? $tCaption('Please answer this question') : null", v-if="!question.__hidden", :class="{ 'disabled-controls': question.__disabled }")
				.flex-row.wrap(v-if="demos.length")
					.flex-row.space-medium.demo.align-center.center.clickable.hoverable.flex-1(v-for="demo in demos", @click="togglePlayDemo(demo)")
						fas(:icon="(isPlayingDemo === demo.Oid ? isAudioLoading ? 'spinner' : 'stop' : 'play')", :spin="!!isAudioLoading && isPlayingDemo === demo.Oid")
						span {{demo.Name}}
				.flex-row.wrap(v-if="activeStep.__hasAdvancedControls")
					.advanced-controls-button.flex-row.space.align-center.clickable.hoverable(@click="activeStep.__advancedControlsVisible = !activeStep.__advancedControlsVisible", 
						:class="{ active: activeStep.__advancedControlsVisible  }")
						.icon
							fas(:icon="activeStep.__advancedControlsVisible ? 'fas fa-square-check' : 'far fa-square'")
						span {{$tCaption('Advanced controls')}}
				.flex-col.space-large(v-if="activeStep", v-show="activeStep.__advancedControlsVisible")
					.flex-row.space(v-for="row in activeStep.RowsAdvanced", v-if="row.some(f => f && f.__isVisible && !f.__hidden)")
						Question(v-for="(question, idx) in row.filter(f => f.__isVisible)", :question="question", :info="info", :questionTypes="questionTypes", :key="question.Oid", :requiredExists="requiredExists",
							:error="requiredExists && question.IsRequired && !question.__filled ? $tCaption('Please answer this question') : null", v-if="!question.__hidden", :class="{ 'disabled-controls': question.__disabled }")
			.flex-col.space-medium.full-width
				.actions-divider.full-width
				.flex-row.max-limited.navigation-row.justify
					.flex-row.align-center
						DxButton(v-if="activeStepIdx === 0 && hasFilledLastAnswers", :text="$tCaption('Clear previous results')", icon="refresh", @click="clearPreviousResults")
					.flex-row.space
						DxButton(v-if="info.allowBack() && (!isFirst || !info.skippedSteps.template)", :text="$tCaption('Back', '@actions')", @click="gotoQuestion(-1)", :activeStateEnabled="false", :focusStateEnabled="false")
						DxButton(:text="$tCaption('Next', '@actions')", type="default", @click="gotoQuestion(1)", :activeStateEnabled="false", :focusStateEnabled="false")
		Loader(v-if="isLoading", :text="$tCaption('Loading brief') + '..'", :fullscreen="true")
		Loader(v-if="isFinalizing", :text="$tCaption('Processing brief') + '..'", :fullscreen="true")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import Question from './EasyCreativeQuestion.vue';
	import helper from './helper';
	import { DxPopover } from 'devextreme-vue/popover';
	import { questionTypes } from './helper';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-questions',
		props: ['info'],
		components: {
			Loader, DxButton, Question, DxPopover
		},
		data() {
			return {
				brief: null,
				steps: null,
				isLoading: false,
				activeStepIdx: 0,
				requiredExists: false,
				questionTypes,
				isTooltipVisible: false,
				isFinalizing: false,
				isPlayingDemo: null,
				isAudioLoading: false,
				hasFilledLastAnswers: false
			};
		},
		computed: {
			allQuestions() {
				const questions = (this.orderedSteps || []).reduce((arr, step) => {
					arr.push(...(step?.Questions || []));
					return arr;
				}, []);

				return _.orderBy(questions, ['Order']);
			},
			allVisibleQuestions() {
				const questions = (this.orderedSteps || []).reduce((arr, step) => {
					arr.push(...step.__visibleQuestions);
					return arr;
				}, []);

				return _.orderBy(questions, ['Order']);
			},
			isFirst() {
				return this.activeStepIdx === 0;
			},
			isLast() {
				return this.activeStepIdx === Math.max(0, this.orderedSteps.length-1);
			},
			activeStep() {
				return this.orderedSteps && this.orderedSteps[this.activeStepIdx] || null;
			},
			orderedSteps() {
				return _.orderBy(this.steps, ['Order']).filter(f => !f.Hidden);
			},
			demos() {
				return this.activeStep?.Demos || [];
			},
			advertiserName() {
				const advertiserQuestion = this.allQuestions.find(f => (f.PromptValue || '').toLowerCase() === 'advertiser');
				return advertiserQuestion?.__displayValue;
			},
			isLastAnswersSaved: {
				get: function() {
					const answers = this.info.lastAnswers();
					return answers && !answers?.CreativeId;
				},
				cache: false
			}
		},
		watch: {
			'info.briefId'() {
				this.loadBrief();
			},
			orderedSteps(v) {
				this.$emit('steps', v && v.length > 1 && v.map(f => f.Name));
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeQuestions = this;
			this.loadBrief();

			this.$eventsBus.$on('easy-creative-generate-answers', this.onGenerateAnswers);
		},
		destroyed() {
			this.$eventsBus.$off('easy-creative-generate-answers', this.onGenerateAnswers);
		},
		methods: {
			async onGenerateAnswers(data) {
				this.isLoading++;
				try {
					await this.info.loadLastPassedBrief({ generate: true, data });
					this.restoreAnswers();
				} finally {
					this.isLoading--;
				}
			},
			getHasFilledLastAnswers() {
				const answers = this.info.lastAnswers();
				return answers && this.allQuestions.filter(f => ['list', 'radioGroup', 'text',  'number', 'currency', 'email', 'websiteUrl', 'file', 'productName'].includes(f.__type)).some(q => {
					const a = answers.AnswerItems.find(a => a.Question === q.Question);
					if (!a) return false;
					switch(q.__type) {
						case 'radioGroup':
						case 'list': {
							const defItem = q.BriefPickListItems?.find(f => f.IsDefault);
							return a.Value && a.Value !== defItem?.Oid;
						}
						default:
							return a.Value !== q.__value;
					}
				});
			},
			clearPreviousResults() {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to start new brief?'),
					handler: () => {
						this.allQuestions.map(f => {
							if (!this.processQuestionDefaults(f)) {
								this.setQuestionValueByAnswer(f, { Value: null, DisplayValue: null }, true);
							}
						});
						this.info.saveBriefAnswers();
						this.hasFilledLastAnswers = false;
					}
				});
			},
			restoreAnswers() {
				const lastAnswers = this.info.lastAnswers();
				if (lastAnswers) {
					this.allQuestions.map(q => {
						const answer = lastAnswers.AnswerItems.find(a => a.Question === q.Question);
						if (answer) {
							this.setQuestionValueByAnswer(q, answer);
						}
					});

					this.hasFilledLastAnswers = this.getHasFilledLastAnswers();
				}

				this.processIntegrationAnswers();
			},
			processIntegrationAnswers() {
				if (!this.info.integration?.answers?.length) return;

				const integrationAnswers = this.info.integration?.answers;

				if (__DEBUG__)
					console.debug('processIntegrationAnswers', { integrationAnswers });

				if (!integrationAnswers?.length) return;

				integrationAnswers.map(a => {
					const question = this.allQuestions.find(f => 
						(a.prompt && `${f.PromptValue}`.toLowerCase() === `${a.prompt}`.toLowerCase()) || 
						(a.question && `${f.Question}`.toLowerCase() === `${a.question}`.toLowerCase())
					);

					if (!question) return;

					if (a.hasOwnProperty('hidden')) {
						question.__hidden = a.hidden;
					}

					if (a.hasOwnProperty('disabled')) {
						question.__disabled = a.disabled;
					}

					if (question.ClientRequest) {
						this.setQuestionValueByAnswer(question, { Value: a.value }, true);
					} else {
						this.setQuestionValueByAnswer(question, { DisplayValue: a.value }, true);
					}
				});
			},
			togglePlayDemo(demo) {
				if (this.isPlayingDemo) {
					this.$Data.safe(() => this.$playingAudio.pause());
				}
				if (this.isPlayingDemo === demo.Oid) {
					this.isPlayingDemo = null;
				} else {
					this.isAudioLoading++;
					this.$playingAudio = new Audio();
					this.$playingAudio.src = demo?.AudioFile.AzureFileUrl;
					this.$playingAudio.play();
					this.$playingAudio.addEventListener('ended', () => this.isPlayingDemo = null);
					this.$playingAudio.addEventListener('canplaythrough', () => this.isAudioLoading--);
					this.$playingAudio.addEventListener('error', () => this.isAudioLoading--);
					this.isPlayingDemo = demo.Oid;
				}
			},
			async gotoQuestion(direction) {
				if (this.isLast && direction > 0) {
					if (this.checkRequired()) {
						this.hasFilledLastAnswers = true;
						if (this.allVisibleQuestions.length) {
							this.isFinalizing++;
							await Promise.all(this.allVisibleQuestions.map(f => f.__finalize())).finally(() => this.isFinalizing--);
						}
						this.$emit('next');
						this.info.saveBriefAnswers();
					}
				} else if (this.isFirst && direction < 0) {
					if (this.info.skippedSteps.template) return;
					this.$emit('back');
					this.info.saveBriefAnswers();
				} else {
					if (direction < 0 || this.checkRequired()) {
						this.activeStepIdx = Math.min(this.orderedSteps.length-1, Math.max(0, this.activeStepIdx + direction));
						this.info.saveBriefAnswers();
						this.$emit('active-step-changed');
					}
				}
			},
			async finalizeQuestion(question) {
				if (question.__type === 'file' && question.FileEditorType === 0 && question.__file && !question.FileAnswer) {
					const container = 'briefs';
					const file = question.__file;
					await this.$azure.uploadBlobWithInfoResponse(`${this.info.briefId}__${question.Oid}__${this.$Data.uuid().substr(6)}__${file.name}`, file, container)
						.then(r => {
							this.$set(question, 'FileAnswer', r?.AzureFileUrl);
						})
				}
			},
			processQuestionDefaults(q) {
				switch(this.questionTypes[q.BriefQuestionType]) {
					case 'radioGroup':
					case 'list':
						if (q?.BriefPickListId) {
							const defaultValue = q.BriefPickListItems.find(f => f.IsDefault);
							if (defaultValue) {
								q.PickListAnswerId = defaultValue.Oid;
								q.BriefPickListDisplayValue = defaultValue.Name;
								return true;
							}
						}
						return;
				}
			},
			async loadBrief() {
				if (!this.info.briefId) return;
				this.activeStepIdx = 0;
				try {
					this.isLoading++;
					if (this.info.predefined?.steps) {
						this.steps = this.info.predefined.steps;
					} else {
						await Promise.all([
							(this.info?.brief ? Promise.resolve(this.info.brief) : this.$Data.getExternalApi('Brief/GetBrief', `id=${this.info.briefId}`)).then(r => this.brief = r),
							this.$Data.getExternalApi('BriefStep/GetAllSteps', `briefId=${this.info.briefId}`, 999).then(r => this.steps = r?.Results || [])
						]);
					}
					if (this.steps.length) {
						const isPickListQuestionHasAnswer = (questionId, answerId) => {
							const question = this.allQuestions?.find(f => f?.Oid === questionId);
							return question?.__value === answerId || question?.PickListParentAnswerIds?.includes(answerId);
						}
						let processStepQuestions = (f, questions) => {
							questions.map(q => {
								q.Step = f;
								Object.defineProperty(q, '__value', {
									get: () => this.getQuestionValue(q)
								});
								Object.defineProperty(q, '__displayValue', {
									get: () => this.getQuestionValue(q, true)
								});
								Object.defineProperty(q, '__type', {
									get: () => this.questionTypes[q.BriefQuestionType]
								});
								Object.defineProperty(q, '__isHierarchical', {
									get: () => !!q.BriefPickListItems?.some(f => f?.SubItems?.length)
								});
								const finalize = () => this.finalizeQuestion(q);
								Object.defineProperty(q, '__finalize', {
									get: () => finalize
								});
								
								Object.defineProperty(q, '__isVisible', {
									get: () => (!q.DependsOnQuestion || !q.DependsOnItem) || isPickListQuestionHasAnswer(q.DependsOnQuestion.Oid, q.DependsOnItem.Oid)
								});

								Object.defineProperty(q, '__filled', {
									get: () => this.getQuestionIsFilled(q)
								});

								q.LogicalAnswer = null;
								q.__LogicalAnswer = null;
								q.BriefPickListDisplayValue = null;
								q.PickListAnswerId = null;
								q.DateAnswer = null;
								q.TimeAnswer = null;
								q.NumberAnswer = null;
								q.CurrencyAnswer = null;
								q.RangeAnswer = null;
								q.__fileName = null;
								q.Answer = null;
								q.__hidden = false;
								q.__disabled = false;
							});
							this.$set(f, 'Questions', questions);
							let main = questions.filter(f => !f.ShowInAdvancedControls && !f.TargetTab?.Oid);
							let advanced = questions.filter(f => f.ShowInAdvancedControls && !f.TargetTab?.Oid);

							this.$set(f, 'Rows', _.groupBy(questions, f => f.Order || 0));
							this.$set(f, 'RowsMain', _.groupBy(main, f => f.Order || 0));
							this.$set(f, 'RowsAdvanced', _.groupBy(advanced, f => f.Order || 0));
							this.$set(f, '__advancedControlsVisible', false);
							this.$set(f, '__hasAdvancedControls', advanced.length > 0);

							questions.filter(q => q.__type === 'tabs').map(q => {
								(q.Tabs || []).map(tab => {
									this.$set(tab, 'Rows', _.groupBy(questions.filter(a => a.TargetTab?.Oid === tab.Oid), f => f.Order || 0));
								});
							});

							if (questions.some(q => q.BriefPickListId) && !this.info.predefined) {
								return Promise.all(questions.filter(q => q.BriefPickListId).map(q => this.$Data.getExternalApi('BriefPickListItem/GetAllBriefPickListItems', `briefPickListId=${q.BriefPickListId}`)
									.then(r => {
										q.BriefPickListItems = _.orderBy(r?.Results || (Array.isArray(r) ? r : []), f => f.Order || 0);
										this.processQuestionDefaults(q);
									})))
							}
							return questions;
						}
						if (this.info.predefined?.stepsQuestions) {
							await Promise.all(this.info.predefined.stepsQuestions.map(async (questions, idx) => {
								let step = this.steps[idx];
								await processStepQuestions(step, questions);
							}));
						} else {
							await Promise.all(this.steps.map(f => this.$Data.getExternalApi('BriefItem/GetAllBriefItems', `stepId=${f.Oid}&briefId=${this.info.briefId}`, 999).then(async r => {
								const questions = _.orderBy(r?.Results || [], [f => f.Order, f => f.IndexInRow || 0]);
								await processStepQuestions(f, questions);
								return questions;
							})));
						}

						this.steps.map(f => {
							Object.defineProperty(f, '__visibleQuestions', {
								get: () => f.Questions.filter(q => q.__isVisible),
								enumerable: true
							})
							if (f.Order === void 0) {
								this.$set(f, 'Order', _.min(f.Questions.map(q => q.Order)));
							}
						});

						//DISABLED: used for fast change when audio generated, need to add new bool prop in Questions to use instead of ShowInAdvancedControls
						//this.info.fastChange.questions = this.allQuestions.filter(f => f.ShowInAdvancedControls);
						//this.info.fastChange.enabled = this.info.fastChange.questions.length > 0;
					}
					
					if (!this.info.lastAnswers()?.CreativeId) {
						this.restoreAnswers();
					}
				} finally {
					this.isLoading--;
				}
			},
			getQuestionIsFilled(q) {
				switch(this.questionTypes[q.BriefQuestionType]) {
					case 'list':
					case 'radioGroup':
					case 'logical':
					case 'date':
					case 'time':
					case 'number':
					case 'currency':
					case 'file':
					case 'audioToText':
					case 'language':
					case 'text':
					case 'websiteUrl':
					default:
						return !!q.__displayValue;
					case 'range':
						return q.RangeAnswer[0] != null && q.RangeAnswer[1] != null;
					case 'email':
						return q.Answer?.name && q.Answer?.email;
					case 'productName':
						return q.Answer?.product && q.Answer?.result;
				}
			},
			isSameQuestionTypeGroup(question, type) {
				const groups = [['logical'], ['list', 'radiogroup'], ['text', 'websiteUrl', 'date', 'time', 'number', 'currency', 'audioToText'], ['range'], ['file'], ['language'], ['email'], ['productName']];
				const currentGroupIdx = groups.findIndex(f => f.includes(question.__type));
				return currentGroupIdx === groups.findIndex(f => f.includes(type));
			},
			getQuestionValue(q, displayValue) {
				switch(this.questionTypes[q.BriefQuestionType]) {
					case 'logical':
						return displayValue ? (q.LogicalAnswer ? this.$tCaption('Yes', '@actions') : this.$tCaption('No', '@actions')) : q.LogicalAnswer;
					case 'list':
					case 'radioGroup':
						return displayValue ? q.BriefPickListDisplayValue : q.PickListAnswerId;
					case 'date': {
						const date = new Date(q.DateAnswer) > new Date(1902,1,1) ? q.DateAnswer : null;
						return displayValue && date ? this.$moment(q.DateAnswer).format('YYYY-MM-DD') : date;
					}
					case 'time':
						return q.TimeAnswer;
					case 'number':
						return q.NumberAnswer;
					case 'currency':
						return q.CurrencyAnswer;
					case 'range':
						return displayValue ? (q.RangeAnswer?.length && `${q.RangeAnswer[0]}-${q.RangeAnswer[1]}` || '') : q.RangeAnswer;
					case 'file':
						if (q.FileEditorType === 1) {
							return q.Answer;
						}
						return q.FileAnswer || q.__fileName;
					case 'audioToText':
						return q.Answer;
					case 'email':
						return !q.Answer?.name || !q.Answer?.email ? null : (displayValue ? `${q.Answer?.name} <${q.Answer?.email}>` : q.Answer);
					case 'language':
						return !q.Answer?.text || !q.Answer?.locale ? null : (displayValue ? q.Answer.text : q.Answer);
					case 'websiteUrl': {
						if (q.ClientRequest) {
							return displayValue ? (q.Answer?.info || '') : q.Answer?.websiteUrl;	
						}
						return displayValue ? (q.Answer || '').replace(/http(s)?:\/\//g, '') : q.Answer;
					}
					case 'productName': {
						return displayValue ? q.Answer?.result : q.Answer;
					}
					default:
					case 'text':
						return q.Answer;
				}
			},
			setQuestionValueByAnswer(q, answer, force) {
				if (!force && !(answer.DisplayValue || answer.Value)) return;

				if (__DEBUG__)
					console.debug('setQuestionValueByAnswer', { q, answer });

				switch(this.questionTypes[q.BriefQuestionType]) {
					case 'logical':
						q.LogicalAnswer = `${answer.Value}`.toLowerCase() === 'true';
						q.__LogicalAnswer = q.LogicalAnswer;
						return;
					case 'list':
					case 'radioGroup':
						q.BriefPickListDisplayValue = answer.DisplayValue;
						q.PickListAnswerId = answer.Value;
						if (!answer.Value && answer.DisplayValue) {
							const pickValue = q.BriefPickListItems.find(f => f.Name == answer.DisplayValue);
							if (pickValue) {
								q.PickListAnswerId = pickValue.Oid;
								q.BriefPickListDisplayValue = pickValue.Name;
							}
						}
						return;
					case 'date': {
						q.DateAnswer = this.$moment(q.DisplayValue).toDate();
						return;
					}
					case 'time':
						q.TimeAnswer = answer.DisplayValue;
						return;
					case 'number':
						q.NumberAnswer = parseFloat(answer.DisplayValue);
						return;
					case 'currency':
						q.CurrencyAnswer = parseFloat(answer.DisplayValue);
						return;
					case 'range':
						q.RangeAnswer = answer.Value && JSON.parse(answer.Value) || null;
						return;
					case 'file':
						if (q.FileEditorType === 1) {
							q.Answer = answer.DisplayValue;
						} else {
							q.__fileName = answer.DisplayValue;
						}
						return;
					case 'audioToText':
						q.Answer = answer.DisplayValue;
						return;
					case 'email':
						q.Answer = answer.Value && JSON.parse(answer.Value) || null;
						return;
					case 'language':
						q.Answer = answer.Value && JSON.parse(answer.Value) || null;
						return;
					case 'productName':
						if (!answer.Value && answer.DisplayValue && q.Answer) {
							q.Answer.product = answer.DisplayValue;
						} else {
							q.Answer = answer.Value && JSON.parse(answer.Value) || null;
						}
						return;
					case 'websiteUrl':
						if (q.ClientRequest) {
							q.Answer = {
								websiteUrl: answer.Value,
								info: answer.DisplayValue
							}
						} else {
							if (answer.Value) {
								q.Answer = answer.Value;
							} else {
								q.Answer = answer.DisplayValue;
							}
						}
						return;
					default:
					case 'text':
						if (answer.Value) {
							q.Answer = answer.Value;
						} else {
							q.Answer = answer.DisplayValue;
						}
						return;
				}
			},
			checkRequired() {
				this.requiredExists = this.activeStep.__visibleQuestions.some(q => q.IsRequired && !q.__filled);
				if (this.requiredExists) {
					this.$notifyWarning('Please answer the marked questions');
				}
				return !this.requiredExists;
			},
			getFormedResults() {
				return this.orderedSteps.map(s => {
					return {
						step: {
							Name: s.Name,
							Oid: s.Oid
						},
						questions: s.__visibleQuestions.filter(f => !['info'].includes(f.__type)).map(q => {
							const res = {
								QuestionId: q.Oid,
								Question: q.Question,
								Answer: q.__displayValue || '',
								AiPrompt: q.AiPrompt
							}
							if (q.__displayValue !== q.__value) {
								res.AnswerValue = q.__value;
							}
							return res;
						})
					}
				});
			},
			getFormedResultsRTF(save) {
				return helper.getFormedResultsRTF(this.getFormedResults(), save);
			},
			getCreativePublishEmail() {
				return this.allQuestions.find(f => f.__type === 'email' && f.EmailAim === 1)?.__displayValue;
			},
			getCreativeName() {
				return this.allQuestions.find(f => f.Meaning === 1)?.__displayValue;
			},
			getCreativeISCI() {
				return this.allQuestions.find(f => f.Meaning === 2)?.__displayValue;
			}
		}
	};
</script>
<style lang='scss'>
	.easy-creative--questions {
		min-height: 300px;

		@media all and (min-width: 720px) {
			width: 720px;
		}
		
		.navigation-row {
			margin-bottom: 20px;
		}

		.step {
			.step-image-holder {
				position: relative;
				width: 95px;
				.step-image {
					position: absolute;
					width: 80px;
					height: 80px;
					background-image: var(--imageUrl);
					background-size: cover;
					border-radius: 100px;
					border: 2px solid #e4e4e4;
					left: 0px;
					top: -16px;
				}
			}
		}

		.demo {
			padding: 20px;
			margin: 4px;
			background: #fff;
			border-radius: 4px;
			max-width: 240px;
		}

		.advanced-controls-button {
			font-weight: 100;
			user-select: none;
			transition: 0.2s;
			
			&.active {
				color: var(--branding-highlight-color) !important;
			}
		}
	}
</style>
